import { createContext, type ReactNode, useContext } from 'react';
import { useMatches } from 'react-router';

const PlayerPersistenceContext = createContext(true);

export function PlayerPersistenceProvider({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactNode;
}) {
  return (
    <PlayerPersistenceContext.Provider value={enabled}>
      {children}
    </PlayerPersistenceContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function usePlayerPersistenceEnabled(): boolean {
  return useContext(PlayerPersistenceContext);
}

export function RoutePlayerPersistenceProvider({ children }: { children: ReactNode }) {
  const routeMatches = useMatches();
  const enabled = !routeMatches.some(
    (match) =>
      (match.handle as { playerPersistence?: 'disabled' } | undefined)?.playerPersistence ===
      'disabled'
  );

  return <PlayerPersistenceProvider enabled={enabled}>{children}</PlayerPersistenceProvider>;
}
